import React from 'react';
import PropTypes from 'prop-types';
import EmptyListStyles from 'components/admin/businesses/devices/EmptyList.module.scss';

import {ReactComponent as WasherIcon} from 'assets/images/icon_washer.svg';

export function EmptyList({ error }) {
  return (
    <div className={EmptyListStyles.noCustomersContainer}>
      <WasherIcon fill="#3790f4" className={EmptyListStyles.illustration} />
      {error && (
        <div className={EmptyListStyles.error}>
          <div>{error}</div>
        </div>
      )}
      {!error && (
        <div className={EmptyListStyles.error}>
          <div>No CENTS devices assigned yet.</div>
          <div>Upload CSV file with device Ids</div>
        </div>
      )}
    </div>
  );
}

EmptyList.propTypes = {
  error: PropTypes.string,
};
